import { useTranslation } from 'react-i18next';
import CategoryDropdown from '@/components/feature/CategoryDropdown';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="scroll-mt-20">
      <div className="mx-auto max-w-content px-4 md:px-6 py-12 md:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t('categories.title')}
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            {t('categories.subtitle')}
          </p>
        </div>

        <div className="mt-8 flex justify-center">
          <CategoryDropdown label={t('categories.dropdownLabel')} />
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.link}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="aspect-square w-full overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} products`}
                  title={`${cat.name} products on Basetao Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between gap-2 p-3">
                <span className="truncate text-sm font-medium text-foreground-800">
                  {cat.name}
                </span>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-up-line text-xs" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}